import { render, staticRenderFns } from "./UniformOrdersRegisterDetail.vue?vue&type=template&id=4d4665ed&"
import script from "./UniformOrdersRegisterDetail.vue?vue&type=script&lang=js&"
export * from "./UniformOrdersRegisterDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports